<template>
  <transition name="fade">
    <div v-if="isOpen" class="window-overlay" @click.self="close">
      <div class="window-container">
        <component :is="filterSortComponent" />
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { appDict } from "@/features/FeatureHelper";

export default {
  name: "FilterSortWindow",

  computed: {
    ...mapGetters('inlineDrawers', ['isFilterSortWindowOpen']),
    isOpen() {
      
      return this.isFilterSortWindowOpen;
    },
    filterSortComponent() {
     return appDict.inlineFilterSelector;
    }
  },

  methods: {
    ...mapActions('inlineDrawers', ['setFilterSortWindowOpen']),
    close() {
       this.setFilterSortWindowOpen(false);
    }
  }
};
</script>
<style lang="css">
.window-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(0,0,0,0.4);
}

.window-container {
  background: rgb(246, 241, 241);
  width: 100%;
  overflow: auto;
}

</style>